import { fromJS } from 'immutable';

export const GET_AUTH_STATUS =
  'modules/travel-lounge-finder-root/GET_AUTH_STATUS';
export const SET_AUTH_STATUS =
  'modules/travel-lounge-finder-root/SET_AUTH_STATUS';

export const getAuthentication = () => ({
  type: GET_AUTH_STATUS,
  isLoading: true,
});

export const setAuthentication = (isAuthenticated = false) => ({
  type: SET_AUTH_STATUS,
  isAuthenticated,
});

const initialState = fromJS({
  isLoading: false,
  isAuthenticated: null,
});

export const authReducer = (state = initialState, action = {}) => {
  switch (action?.type) {
    case GET_AUTH_STATUS:
      return state.set('isLoading', action.isLoading);
    case SET_AUTH_STATUS:
      return state
        .set('isAuthenticated', !!action.isAuthenticated)
        .set('isLoading', false);
    default:
      return state;
  }
};
